import PropTypes from 'prop-types';
import MuiDialogActions from '@mui/material/DialogActions';
import { getVariantBgColor } from './dialog.styles';

/**
 * Renders a <DialogActions /> component.
 * @param {object} props Any unaccounted properties will be available from restActionsProps.
 * @param {Array} props.children
 * @param {string} props.variant
 * @param {string} props.align
 * @returns {React.Component}
 */

export const DialogActions = ({
  // eslint-disable-next-line react/prop-types
  children,
  variant = 'primary',
  align = 'right',
  sx = {},
  ...restActionsProps
}) => (
  <MuiDialogActions
    sx={{
      alignItems: align,
      justifyContent: align,
      display: 'flex',
      backgroundColor: getVariantBgColor(variant),
      borderBottomRightRadius: 4,
      borderBottomLeftRadius: 4,
      m: 0,
      p: {
        xs: 2,
        sm: 4,
      },
      ...sx,
    }}
    {...restActionsProps}
  >
    {children}
  </MuiDialogActions>
);

DialogActions.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  variant: PropTypes.oneOf(['primary', 'destructive']),
  align: PropTypes.oneOf(['left', 'center', 'right']),
};
